import { render, staticRenderFns } from "./CreditNoteCreateButtons.vue?vue&type=template&id=2cab1069&"
import script from "./CreditNoteCreateButtons.vue?vue&type=script&lang=js&"
export * from "./CreditNoteCreateButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cab1069')) {
      api.createRecord('2cab1069', component.options)
    } else {
      api.reload('2cab1069', component.options)
    }
    module.hot.accept("./CreditNoteCreateButtons.vue?vue&type=template&id=2cab1069&", function () {
      api.rerender('2cab1069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/accounts/CreditNoteCreateButtons.vue"
export default component.exports